import { getConfig } from 'config';
import { getData } from '../dataProvider';

const CAPS_API_DOMAIN_STAGING = 'https://caps-backend-stage-va6.adobe.io';
const CAPS_API_DOMAIN_PRODUCTION = 'https://caps-backend.adobe.io';
const CAPS_UI_PATH = '/static/caps-ui.js';

// Determine the API host based on the API domain
// For local development, use the local caps backend i.e. add
// if (apiDomain.includes('127.0.0.1')) return 'http://localhost';
const getApiHost = () => {
  const apiDomain = getConfig('apiDomain');
  // CAPS staging requires staging IMS client - SWAT is using production IMS client
  // so we always use production API domain
  //if (apiDomain.includes('stg.')) return CAPS_API_DOMAIN_STAGING;
  return CAPS_API_DOMAIN_PRODUCTION;
};

// Get the API host
const API_HOST = getApiHost();

// CAPS configuration constants
export const CAPS_CONFIG = {
  API_URL: API_HOST,
  UI_URL: API_HOST + CAPS_UI_PATH,
  ENDPOINTS: {
    TOKEN: '/token'
  }
};

// This function is used to load the IMS token
export const loadImsToken = () => {
  return getData(`${getConfig('apiDomain')}${CAPS_CONFIG.ENDPOINTS.TOKEN}`);
};
